import Layout from "../components/Layout";
import { InventoryManagement } from "../components/_Inventory/InventoryManagement";

const InventoryManagementPage = (props: any) => {
  return (
    <Layout>
        <InventoryManagement />
    </Layout>
  )
}

export default InventoryManagementPage